import { AlertProvider, AuthProvider } from 'components/providers'
import { RouterProvider } from 'react-router'
import { useDefaultFont } from 'utils'
import router, { routes } from './utils/routing'

function App() {
  useDefaultFont()
  return (
    <AlertProvider>
      <AuthProvider routes={routes}>
        <RouterProvider router={router} />
      </AuthProvider>
    </AlertProvider>
  )
}

export default App
